import styled from "styled-components";

export const LogoutDialogWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  padding: 24px 15px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;
  border-radius: 12px;
  background: #fff;
`;

export const LogoutDialogContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;.
  color: var(--Black-500, #202020);
  text-align: center;
  font-family: Pretendard;
  font-size: 25px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%; /* 35px */

  > img {
    width: 148px;
    height: 148px;
    aspect-ratio: 1/1;
  }

  > .description {
    font-size: 16px;
    font-weight: 500;
    line-height: 140%; /* 22.4px */
  }
`;

export const LogoutButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const LogoutCurrentButton = styled.div`
  display: flex;
  width: 484px;
  padding: 15px 0;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  background: #7f25fb;
  color: #fff;
  text-align: center;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.165px;
  cursor: pointer;
`;

export const LogoutAllButton = styled(LogoutCurrentButton)`
  border: 1px solid #d91818;
  color: #d91818;
  background: #fff;
`;

export const LogoutCancelButton = styled(LogoutCurrentButton)`
  border: none;
  color: #121212;
  background: #fff;
`;
